export default "__VITE_ASSET__CDFMAsv5__"